export default __webpack_public_path__ + "static/media/download.ed6268b9.svg";